import { isFeatureEnabled, GTM_INJECT_THIRDPARTY, GTM_COLLECT_ANALYTICS } from '../clients/FeaturesClient';

const injectScript = (content) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.innerHTML = content;

  document.head.appendChild(script);
};

const injectTrustArc = () => {
  const queryParams =
    'domain=moo.com&privacypolicylink=http%5A%2F%2Fmoo.com%2Fabout%2Fprivacy-policy&text=true&language=gb&js=nj&noticeType=bb';

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.crossOrigin = 'anonymous';
  script.src = `//consent.truste.com/notice?${queryParams}`;

  document.head.appendChild(script);
};

const answerdash = `
  var AnswerDash;
  !(function(e, t, n, s, a) {
    if (!t.getElementById(s)) {
      var i,
        r = t.createElement(n),
        c = t.getElementsByTagName(n)[0];
      e[a] ||
        ((i = e[a] = function() {
          i.__oninit.push(arguments);
        }),
          (i.__oninit = [])),
        (r.type = 'text/javascript'),
        (r.async = !0),
        (r.src = 'https://p1.answerdash.com/answerdash.min.js?siteid=950'),
        r.setAttribute('id', s),
        c.parentNode.insertBefore(r, c);
    }
  })(window, document, 'script', 'answerdash-script', 'AnswerDash');
`;

const livechat = `
  window.__lc = window.__lc || {};
  window.__lc.license = 2070511;
  (function() {
    var lc = document.createElement('script');
    lc.type = 'text/javascript';
    lc.async = true;
    lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(lc, s);
  })();
  var LC_API = LC_API || {};
  LC_API.on_before_load = function() {
    if (LC_API.visitor_engaged() === false) {
      LC_API.hide_chat_window();
    }
  };
`;

const gaCode = window.gaCode || '';
const ga = `
  (function(i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    (i[r] =
      i[r] ||
      function() {
        (i[r].q = i[r].q || []).push(arguments);
      }),
      (i[r].l = 1 * new Date());
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
  window.ga('create', '${gaCode}', 'auto');
`;

const gtmContainerId = window.gtmContainerId || '';
const gtm = `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${gtmContainerId}');
`;

export default {
  injectScripts: () => {
    if (isFeatureEnabled(GTM_INJECT_THIRDPARTY) || isFeatureEnabled(GTM_COLLECT_ANALYTICS)) {
      injectTrustArc();
      injectScript(gtm);
    } else if (!isFeatureEnabled(GTM_COLLECT_ANALYTICS)) {
      injectScript(ga);
    }

    if (!isFeatureEnabled(GTM_INJECT_THIRDPARTY)) {
      injectScript(answerdash);
      injectScript(livechat);
    }
  },
};
